export default "__VITE_ASSET__DD5T$SKf__"